const drawMarker = (image: HTMLImageElement, marker: HTMLElement) => {
  // Offsets to tweak placement of marker icon for a given set of coordinates
  const iconXOffset = 19;
  const iconYOffset = 48;

  const coordinates = marker.getAttribute('data-coordinates');
  if (!coordinates) return;

  const relativeX = Number(coordinates.split(',')[0]);
  const relativeY = Number(coordinates.split(',')[1]);

  const offsetX = Math.round((relativeX * image.clientWidth) / 100) - iconXOffset;
  const offsetY = Math.round((relativeY * image.clientHeight) / 100) - iconYOffset;

  marker.setAttribute('style', `left:${offsetX}px;top:${offsetY}px;visibility:visible;`);
};

const NwMap = {
  drawMarker,
};

export default NwMap;
